/**
 * Available procedure modules that can be added to any workspace
 * These are reusable components that work across different sections
 */

import { BarChart3, Layers } from "lucide-react";

export interface ProcedureModule {
  id: string;
  name: string;
  description: string;
  icon: React.ComponentType<{ className?: string }>;
  componentName: string; // Name of the component to render
}

export const PROCEDURE_MODULES: ProcedureModule[] = [
  {
    id: "ageing-analysis",
    name: "Ageing Analysis",
    description: "Perform ageing analysis on data with configurable buckets and date ranges",
    icon: BarChart3,
    componentName: "AgeingAnalysisModule",
  },
  {
    id: "composition-analysis",
    name: "Composition Analysis",
    description: "Document and perform composition analysis procedures",
    icon: Layers,
    componentName: "CompositionAnalysisModule",
  },
];

/**
 * Get a module by its ID
 */
export function getModuleById(moduleId: string): ProcedureModule | undefined {
  return PROCEDURE_MODULES.find(m => m.id === moduleId);
}

/** Stored procedure names for the Ageing module: "Ageing Analysis - <user name>" */
export const AGEING_ANALYSIS_PROCEDURE_PREFIX = "Ageing Analysis - ";

/** Stored procedure names for the Composition module: "Composition Analysis - <user name>" */
export const COMPOSITION_ANALYSIS_PROCEDURE_PREFIX = "Composition Analysis - ";

/**
 * Get a module by its display/stored procedure name (exact or prefixed for named modules).
 */
export function getModuleByName(moduleName: string): ProcedureModule | undefined {
  const exact = PROCEDURE_MODULES.find(m => m.name === moduleName);
  if (exact) return exact;
  if (moduleName.startsWith(AGEING_ANALYSIS_PROCEDURE_PREFIX)) {
    return PROCEDURE_MODULES.find(m => m.id === "ageing-analysis");
  }
  if (moduleName.startsWith(COMPOSITION_ANALYSIS_PROCEDURE_PREFIX)) {
    return PROCEDURE_MODULES.find(m => m.id === "composition-analysis");
  }
  return undefined;
}


